

























import {SelectBox} from "@/interfaces/global-data";
import {Component, Prop, Watch} from "vue-property-decorator";
import Toast from "../mixins/toast";

@Component({
  components: {},
})
export default class MultiSelect extends Toast {
  @Prop() public readonly items!: Array<SelectBox<any>>;
  @Prop() readonly default_value!: Array<SelectBox<any>>;
  @Prop() public readonly search!: string;
  @Prop() readonly select_list!: any[];

  @Prop() public readonly onToggleDropdown!: (open: boolean) => void;

  @Prop() public readonly showTitle?: boolean;
  @Prop() public readonly disabled?: boolean;
  @Prop() public readonly placeholder?: string;
  @Prop() public readonly dropdownClassName?: string;

  // Computed properties for safe prop access
  get isDisabled(): boolean {
      return this.disabled || false;
  }
  
  get cssDropdownClassName(): string {
      return this.dropdownClassName || '';
  }
  
  public selectList: any[] = this.select_list.length === 0 ? [...this.default_value.map((i) => i.value)] : [...this.select_list];
  public emitName: string = "";
  public allSeasonsValues: string = "";
  public loading: Boolean = false;
  public options: Array<SelectBox<any>> = this.items.length === 0 ? [...this.default_value] : this.fixDefaultValue();

  @Watch("items")
  public itemsChange(newItems: Array<SelectBox<string>>, oldItems: any) {
    const options = this.items.filter((i) => {
      return this.default_value.findIndex((e) => {
        return e.value === i.value;
      }) === -1;
    });

    options.unshift(...this.default_value);
    this.options = options;
    this.allSeasonsValues = newItems.filter((item) => item.value !== (this.default_value[0] && this.default_value[0].value)).map((item) => item.value).sort().toString();
  }

  @Watch("select_list")
  public changeSelectList(newVal: Array<SelectBox<string>>, oldValue: any) {
    this.selectList = newVal.length === 0 ? [...this.default_value.map((i) => i.value)] : [...newVal];
  }

  @Watch("default_value")
  public defaultValueChanged() {
      this.allSeasonsValues = this.items.filter((item) => item.value !== (this.default_value[0] && this.default_value[0].value)).map((item) => item.value).sort().toString();
      this.options = this.fixDefaultValue();
  }

  public created() {
    this.allSeasonsValues = this.items.filter((item) => item.value !== (this.default_value[0] && this.default_value[0].value)).map((item) => item.value).sort().toString();
    this.emitName = Object.keys((this as any)._events)[0];
  }

  public changeTagsStyle() {
      const elements = document.getElementsByClassName("ant-select-selection__choice") as HTMLCollectionOf<HTMLElement>;
      for (const item of elements) {
          if (item.style.backgroundColor !== "#E6F7FF") {
              item.style.backgroundColor = "#E6F7FF";
              item.style.borderColor = "#91D5FF";
          }
      }
  }

  public mounted() {
      this.changeTagsStyle();
  }

  public updated() {
      this.changeTagsStyle();
  }

  public inputListener(newSeason: any[] | null) {
    let selectedList = new Array<any>();
    if (newSeason !== null) {
      if (newSeason.length === this.select_list.length) {
        if (newSeason.every((e, i) => {
          return this.select_list[i] === e;
        })) {
          return;
        }
      }
      const seasonValues = newSeason.map((item) => item).sort();
      const value = (this.default_value[0] && this.default_value[0].value)

      // ниже - вернул логику, которая была до предудыщего коммита
      if (newSeason.length === 0 || (seasonValues.toString() === this.allSeasonsValues) || newSeason[newSeason.length - 1] === value) {
        selectedList = [...this.default_value.map((i) => i.value)];
      } else if (newSeason[newSeason.length - 1] !== value) {
        selectedList = newSeason.filter((item) => item !== value);
      }
    }
    this.$emit(this.emitName, selectedList);
  }

  public toggleLoading(status: boolean) {
    this.loading = status;
    // this.$refs.select && (this.$refs.select as any).toggleLoading(status);
    if (status) {
      this.inputListener(null);
    } else {
      this.selectList = this.select_list.length === 0 ? [...this.default_value.map((i) => i.value)] : [...this.select_list];
    }
  }

  public onSearch(str: string, option: any) {
    const val = option.key
    const existedValue = this.options.find(({ value }: { value: number }) => val === value)
    const label = existedValue && existedValue.label.toLocaleLowerCase()

    return label && label.includes(str.toLocaleLowerCase())
  }

  public _onToggleDropdown(isOpen: boolean) {
    if (typeof this.onToggleDropdown === "function") {
      this.onToggleDropdown(isOpen);
    }
  }

  private fixDefaultValue(): Array<SelectBox<any>> {
    const options = this.items.filter((i) => {
      return this.default_value.findIndex((e) => {
        return e.value === i.value;
      }) === -1;
    });
    options.unshift(...this.default_value);
    return options;
  }
}
